export default __webpack_public_path__ + "static/media/icon-quotation-bottom.7ea94df2.svg";